export default {
  specialized_transport: 'specialized_transport',
  basic_transport: 'basic_transport',
  sanitary_transport: 'sanitary_transport',
  multi_transport: 'multi_transport',
  medical_courier: 'medical_courier',
  event: 'event',
}
